// StudentOauthLink.component: OAuth→email link confirm; avatarSrc is CDN-resolved from accountPictureSub (container).
// Mistake: fed raw query URL into img; auth base URL can differ from www REACT_APP_PUBLIC_RESOURCE_URL_PREFIX.
import React, { useState } from "react";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import Header from "./Header.component";

const StudentOauthLinkComponent = (props: any) => {
    const { oauthEmail, oauthProvider, avatarSrc, displayName, isOnNetworking, needsEmailVerification, isSendingVerificationEmail, onSendVerificationEmail, onConfirmLink, onCancel } = props;
    const [pictureFailed, setPictureFailed] = useState(false);

    const providerLabel = (() => {
        const p = (oauthProvider || "").toLowerCase();
        if (p === "google") {
            return getLanguageValue(PAGE_TYPE.COMMON, "studentSignupWizard.oauthProviderGoogle");
        }
        if (p === "kakao") {
            return getLanguageValue(PAGE_TYPE.COMMON, "studentSignupWizard.oauthProviderKakao");
        }
        if (p === "line") {
            return getLanguageValue(PAGE_TYPE.COMMON, "studentSignupWizard.oauthProviderLine");
        }
        if (p === "apple") {
            return getLanguageValue(PAGE_TYPE.COMMON, "studentSignupWizard.oauthProviderApple");
        }
        return oauthProvider || "";
    })();

    const initial = (displayName || oauthEmail || "?").trim().charAt(0) || "?";
    const showPicture = Boolean(avatarSrc) && !pictureFailed;

    return (
        <>
            <Header backUrl="/signup/student" />
            <main className="min-h-screen bg-gray-50 px-4 pb-12 pt-10 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-lg">
                    <h1 className="text-2xl font-bold text-gray-900">
                        {getLanguageValue(PAGE_TYPE.COMMON, "studentOauthLink.txtTitle")}
                    </h1>

                    <div className="mt-6 flex flex-col items-center text-center sm:items-start sm:text-left">
                        <div className="relative h-24 w-24 shrink-0 overflow-hidden rounded-full border border-gray-200 bg-white shadow-sm">
                            {showPicture ? (
                                <img
                                    src={avatarSrc}
                                    alt=""
                                    className="h-full w-full object-cover"
                                    onError={() => setPictureFailed(true)}
                                />
                            ) : (
                                <div className="flex h-full w-full items-center justify-center bg-gray-100 text-2xl font-semibold text-gray-500">
                                    {initial}
                                </div>
                            )}
                        </div>
                        <p className="mt-4 text-lg font-semibold text-gray-900">{displayName || oauthEmail}</p>
                    </div>

                    <p className="mt-4 text-sm text-gray-600">
                        {getLanguageValue(PAGE_TYPE.COMMON, "studentOauthLink.txtIntro")
                            .replace("%EMAIL%", oauthEmail || "")
                            .replace("%PROVIDER%", providerLabel)}
                    </p>
                    {needsEmailVerification ? (
                        <div className="mt-3 space-y-2 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
                            <p>
                                {getLanguageValue(PAGE_TYPE.COMMON, "studentOauthLink.txtNeedEmailVerification")}
                            </p>
                        </div>
                    ) : null}

                    <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="rounded-xl border border-gray-200 px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            {getLanguageValue(PAGE_TYPE.COMMON, "studentSignupWizard.btnOAuthLinkCancel")}
                        </button>
                        {needsEmailVerification ? (
                            <button
                                type="button"
                                onClick={onSendVerificationEmail}
                                disabled={isSendingVerificationEmail || isOnNetworking}
                                className="rounded-xl border border-[#CF3688] px-6 py-3 text-sm font-medium text-[#CF3688] hover:bg-[#CF3688]/5 disabled:opacity-50"
                            >
                                {getLanguageValue(PAGE_TYPE.COMMON, "studentOauthLink.btnSendVerificationEmail")}
                            </button>
                        ) : null}
                        <button
                            type="button"
                            onClick={onConfirmLink}
                            disabled={isOnNetworking || isSendingVerificationEmail}
                            className="rounded-xl bg-[#CF3688] px-6 py-3 text-sm font-medium text-white hover:bg-[#B52E74] disabled:opacity-50"
                        >
                            {getLanguageValue(PAGE_TYPE.COMMON, "studentSignupWizard.btnOAuthLinkConfirm")}
                        </button>
                    </div>
                </div>
            </main>
        </>
    );
};

export default StudentOauthLinkComponent;
